import React from 'react'
import styled from '@emotion/styled'

import { styles } from './styles'
import { useProgress } from './useProgress'

const Bar = styled.div`
  ${styles.progressBar};
`

const ProgressBar = ({ progress }) => {
  return <Bar progress={progress} />
}

ProgressBar.useProgress = useProgress

export default ProgressBar
